export default __webpack_public_path__ + "static/media/proposal2.47e286f6.jpeg";